import Addteacher from "./components/Addteacher.vue";
import Login from "./components/Login.vue";
import NewStudent from "./components/NewStudent.vue"
import Students from "./components/Students.vue";
import Dashboard from "./components/Dashboard.vue"
import NotFound from "./components/NotFound.vue";
import Teachers from "./components/Teachers.vue";
import Sessions from "./components/Sessions.vue"
import AppSetting from "./components/AppSetting.vue"
import SendMes from "./components/SendMes.vue"
import StudentSessions from "./components/StudentSessions.vue"
import AddAdmin from "./components/AddAdmin.vue"
import AllStudents from "./components/AllStudents.vue"
import AddStudent from "./components/AddStudent.vue"
import AllAdmins   from "./components/AllAdmins.vue"
import SessionReport from "./components/SessionReport.vue"
import SummarySessionReport from "./components/SummarySessionReport.vue"
import DailyStudentReport from "./components/DailyStudentReport.vue"
import TeacherCalendar from "./components/TeacherCalendar.vue"
import StudentCalendar from "./components/StudentCalendar.vue"

import TeacherResponseReport from "./components/TeacherResponseReport.vue"
import Organizations from "./pages/Organizations.vue"

import AdminMessages from "./components/AdminMessages.vue"
import StudentSessionsManagement from "./components/StudentSessionsManagement.vue";
import SessionTimeManagement from "./components/SessionTimeManagement.vue";
import AdminNotifications from "./components/AdminNotifications.vue"
import AuditLogs from "./components/AuditLogs.vue"
import TenantsManagement from "./components/TenantsManagement.vue"
import GeneralManagersManagement from "./components/GeneralManagersManagement.vue"
import QualificationsManagement from "./components/QualificationsManagement.vue"
import DurationsManagement from "./components/DurationsManagement.vue"
import MassaratsManagement from "./components/MassaratsManagement.vue"
import RegionsManagement from "./components/RegionsManagement.vue"
import AthanTimesManagement from "./components/AthanTimesManagement.vue"
import GoalsManagement from "./components/GoalsManagement.vue"
import AboutUsManagement from "./components/AboutUsManagement.vue"
import ContactUsManagement from "./components/ContactUsManagement.vue"
import TermsAndConditionsManagement from "./components/TermsAndConditionsManagement.vue"
import TeacherScheduleManagement from "./components/TeacherScheduleManagement.vue"
import PeerReviewReport from "./components/PeerReviewReport.vue"
import SuperAdminGeneralReport from "./components/SuperAdminGeneralReport.vue"
import PermissionGroupsManagement from "./components/PermissionGroupsManagement.vue"
import UserPermissionsManagement from "./components/UserPermissionsManagement.vue"

import { createRouter, createWebHistory } from 'vue-router'


const routes = [
    {
        name: 'NotFound',
        path: '/:pathMatch(.*)*',
        component: NotFound,
    },
    {
        name: 'login',
        component: Login,
        path: '/',
        meta: {
            requiresAuth: false,
        },
    },
    {
        name: 'addteacher',
        component: Addteacher,
        path: '/add/teacher',
        meta: {
            requiresAuth: true,
            pageCode: 'teachers',
        },
    },
    {
        name: 'teachers',
        component: Teachers,
        path: '/view/teachers',
        meta: {
            requiresAuth: true,
            pageCode: 'teachers',
        }
    },
    {
        name: 'newStudent',
        component: NewStudent,
        path: '/new/student',
        meta: {
            requiresAuth: true,
            pageCode: 'new_students',
        },
    },
    {
        name: 'Students',
        component: Students,
        path: '/students',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },
    {
        name: 'AddStudent',
        component: AddStudent,
        path: '/add/student',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },
    {
        name: 'Dashboard',
        component: Dashboard,
        path: '/dashboard',
        meta: {
            requiresAuth: true,
            pageCode: 'dashboard',
        },
    },
    {
        name: 'Sessions',
        component: Sessions,
        path: '/sessions',
        meta: {
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'AppSetting',
        component: AppSetting,
        path: '/appSetting',
        meta: {
            requiresAuth: true,
            pageCode: 'app_settings',
        },
    },
    {
        name: 'SendMes',
        component: SendMes,
        path: '/sendMes',
        meta: {
            requiresAuth: true,
            pageCode: 'reports',
        },
    },
    {
        name: 'StudentSessions',
        component: StudentSessions,
        path: '/studentSessions',
        meta: {
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
      name: 'AllAdmins',
      component: AllAdmins,
      path: '/allAdmins',
      meta: { 
          requiresAuth: true,
          pageCode: 'admins',
      },
    },
    {
        name: 'SummarySessionReport',
        component: SummarySessionReport,
        path: '/SummarySessionReport',
        meta: { 
            requiresAuth: true,
            pageCode: 'reports',
        },
      },
      {
        name: 'DailyStudentReport',
        component: DailyStudentReport,
        path: '/DailyStudentReport',
        meta: { 
            requiresAuth: true,
            pageCode: 'reports',
        },
      },
      
    {
        name: 'AddAdmin',
        component: AddAdmin,
        path: '/addAdmin',
        meta: {
            requiresAuth: true,
            pageCode: 'admins',
        },
    },
    {
        name: 'AllStudents',
        component: AllStudents,
        path: '/allStudents',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },
    {
        name: 'SessionReport',
        component: SessionReport,
        path: '/session-report',
        meta: {
            requiresAuth: true,
            pageCode: 'reports',
        },
    },
    {
        name: 'TeacherCalendar',
        component: TeacherCalendar,
        path: '/teacher-calendar',
        meta: {
            requiresAuth: true,
            pageCode: 'teachers',
        },
    },
    {
        name: 'StudentCalendar',
        component: StudentCalendar,
        path: '/student-calendar',
        meta: {
            requiresAuth: true,
            pageCode: 'students',
        },
    },

    {
        name: 'Organizations',
        component: Organizations,
        path: '/organizations',
        meta: {
            requiresAuth: true,
            pageCode: 'organizations',
        },
    },
    {
        name: 'TeacherResponseReport',
        component: TeacherResponseReport,
        path: '/teacher-response-report',
        meta: {
            requiresAuth: true,
            pageCode: 'reports',
        },
    },

    {
        name: 'AdminMessages',
        component: AdminMessages,
        path: '/admin-messages',
        meta: { 
            requiresAuth: true,
            pageCode: 'admin_messages',
        },
    },
    {
        name: 'SessionTimeManagement',
        component: SessionTimeManagement,
        path: '/session-time-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'StudentSessionsManagement',
        component: StudentSessionsManagement,
        path: '/student-sessions-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'sessions',
        },
    },
    {
        name: 'AdminNotifications',
        component: AdminNotifications,
        path: '/admin-notifications',
        meta: { 
            requiresAuth: true,
            pageCode: 'admin_notifications',
        },
    },
    {
        name: 'AuditLogs',
        component: AuditLogs,
        path: '/audit-logs',
        meta: { 
            requiresAuth: true,
            pageCode: 'audit_logs',
        },
    },
    {
        name: 'TenantsManagement',
        component: TenantsManagement,
        path: '/tenants-management',
        meta: { 
            requiresAuth: true,
            requiresSuperAdmin: true, // Super Admin only - no pageCode needed
        },
    },
    {
        name: 'GeneralManagersManagement',
        component: GeneralManagersManagement,
        path: '/general-managers-management',
        meta: { 
            requiresAuth: true,
            requiresSuperAdmin: true, // Super Admin only - no pageCode needed
        },
    },
    {
        name: 'QualificationsManagement',
        component: QualificationsManagement,
        path: '/qualifications-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'qualifications_management',
        },
    },
    {
        name: 'DurationsManagement',
        component: DurationsManagement,
        path: '/durations-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'durations_management',
        },
    },
    {
        name: 'MassaratsManagement',
        component: MassaratsManagement,
        path: '/massarats-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'massarats_management',
        },
    },
    {
        name: 'RegionsManagement',
        component: RegionsManagement,
        path: '/regions-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'regions_management',
        },
    },
    {
        name: 'AthanTimesManagement',
        component: AthanTimesManagement,
        path: '/athan-times-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'athan_times_management',
        },
    },
    {
        name: 'GoalsManagement',
        component: GoalsManagement,
        path: '/goals-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'goals_management',
        },
    },
    {
        name: 'AboutUsManagement',
        component: AboutUsManagement,
        path: '/about-us-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'about_us_management',
        },
    },
    {
        name: 'ContactUsManagement',
        component: ContactUsManagement,
        path: '/contact-us-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'contact_us_management',
        },
    },
    {
        name: 'TermsAndConditionsManagement',
        component: TermsAndConditionsManagement,
        path: '/terms-and-conditions-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'terms_and_conditions_management',
        },
    },
    {
        name: 'TeacherScheduleManagement',
        component: TeacherScheduleManagement,
        path: '/teacher-schedule-management',
        meta: { 
            requiresAuth: true,
            pageCode: 'teachers',
        },
    },
    {
        name: 'PeerReviewReport',
        component: PeerReviewReport,
        path: '/peer-review-report',
        meta: { 
            requiresAuth: true,
            pageCode: 'peer_review_report',
        },
    },
    {
        name: 'SuperAdminGeneralReport',
        component: SuperAdminGeneralReport,
        path: '/super-admin-general-report',
        meta: { 
            requiresAuth: true,
            requiresSuperAdmin: true, // Super Admin only - no pageCode needed
        },
    },
    {
        name: 'PermissionGroupsManagement',
        component: PermissionGroupsManagement,
        path: '/permission-groups',
        meta: {
            requiresAuth: true,
            pageCode: 'permission_groups',
        },
    },
    {
        name: 'UserPermissionsManagement',
        component: UserPermissionsManagement,
        path: '/user-permissions',
        meta: {
            requiresAuth: true,
            pageCode: 'user_permissions',
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const token = localStorage.getItem("token");
        if (!token) {
            return next({ name: 'login' });
        }
        let isExpired = false;
        try {
            const { exp } = JSON.parse(atob(token.split('.')[1]));
            if (exp * 1000 < Date.now()) {
                isExpired = true;
            }
        } catch (error) {
            isExpired = true;
        }
        if (isExpired) {
            localStorage.clear();
            return next({ name: 'login' });
        }
        const userRole = localStorage.getItem("userRole");
        if (userRole !== 'ADMIN' && userRole !== 'GENERAL_MANAGER' && userRole !== 'SUPER_ADMIN') {
            localStorage.clear();
            return next({ name: 'login' });
        }

        // Check if route requires Super Admin
        if (to.meta.requiresSuperAdmin) {
            if (userRole !== 'SUPER_ADMIN') {
                // Redirect to dashboard if not Super Admin
                return next({ name: 'Dashboard' });
            }
            // Super Admin has access, skip permission checks
            return next();
        }

        // Check permissions if pageCode is specified in route meta
        // ⚠️ Backward Compatibility: If no permissions stored, allow access (system is optional)
        if (to.meta.pageCode) {
            const userRole = localStorage.getItem("userRole");
            
            // Super Admin bypass
            if (userRole === 'SUPER_ADMIN') {
                return next();
            }

            // Check if permissions are stored in localStorage
            const storedPermissions = localStorage.getItem('permissions');
            
            // ⚠️ Backward Compatibility: If no permissions stored, allow access
            // This means the permissions system is optional and doesn't affect existing users
            if (!storedPermissions) {
                return next(); // Allow access if permissions system not configured
            }

            try {
                const permissions = JSON.parse(storedPermissions);
                
                // ⚠️ If permissions object is empty, allow access (backward compatibility)
                if (!permissions || Object.keys(permissions).length === 0) {
                    return next();
                }

                const pagePermissions = permissions[to.meta.pageCode];
                
                // ⚠️ If page not in permissions object, allow access (backward compatibility)
                if (!pagePermissions) {
                    return next();
                }
                
                // Check read permission only if explicitly denied
                // If read is false and user has permission groups, deny access
                if (pagePermissions.read === false) {
                    // Redirect to dashboard if no permission
                    return next({ name: 'Dashboard' });
                }
            } catch (error) {
                console.error('Error parsing permissions:', error);
                // On error, allow access (backward compatibility)
                return next();
            }
        }

        return next();
    }
    return next();
});

export default router;